<template>
  <div class="frame10_body">
    <div class="frame10">
      <div class="frame10_top">
        成长能力
        <img src="../../../../public/img/shares_Info/close.png" alt="" @click="frame10_close"/>
      </div>
      <div class="frame10_content">
        <div class="frame10_content_title">营业总收入TTM</div>
        <div class="frame10_content_text">
          【释义】：是指前推12个月企业在从事销售商品，提供劳务和让渡资产使用权等日常经营业务过程中所形成的经济利益的总流入。  
        </div>
        <div class="frame10_content_text">
          【算法】：营业总收入=营业收入
        </div>
        <div class="frame10_content_text">【单位】：元</div>
      </div>
      <div class="frame10_content">
        <div class="frame10_content_title">归母净利润TTM</div>
        <div class="frame10_content_text">
          【释义】：即前推12个月归属母公司所有者净利润，反映在企业合并报表净利润中，归属母公司股东（所有者）所有的那部分利润。  
        </div>
        <div class="frame10_content_text">
          【算法】：归母净利润=净利润-少数股东损益
        </div>
        <div class="frame10_content_text">【单位】：元</div>
      </div>
      <div class="frame10_content">
        <div class="frame10_content_title">扣非净利润</div>
        <div class="frame10_content_text">
          【释义】：前推12个月扣除非经常性损益后的净利润。是单纯反映企业经营业绩的指标，扣除了公司正常经营损益之外的一次性或偶发性损益。  
        </div>
        <div class="frame10_content_text">
          【算法】：根据报告期”扣除非经常性损益后的净利润“计算: 1)最新报告期是年报，则TTM=年报； 2)最新报告期不是年报，则TTM=本期+（上年年报-上年同期合并数）
        </div>
        <div class="frame10_content_text">【单位】：元</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    methods:{
        frame10_close(){
            this.$emit('frame10_close')
        }
    }
};
</script>

<style scoped>
.frame10_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame10 {
  width: 448px;
  height: 740px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame10_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame10_content {
  margin-top: 28px;
}
.frame10_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame10_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame10_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>